import Toggle from "../../../utils/Toggle/Toggle";
import { CategorySelector } from "../Dialog/CategorySelector";
import styles from "./Product.module.css";

export const ProductFieldInput = ({
  label,
  type,
  value,
  placeholder,
  required,
  onChange,
  name,
  suffix,
  disabled = false,
  stacked = false,
  options = [],
}) => {
  const isStacked = stacked || ["textarea", "list"].includes(type);

  const renderControl = () => {
    if (type === "toggle") {
      return (
        <div className={styles.inputToggle}>
          <span className={styles.toggleState}>
            {value ? "Enabled" : "Disabled"}
          </span>
          <Toggle
            status={Boolean(value)}
            setStatus={(newValue) => onChange(newValue)}
          />
        </div>
      );
    }

    if (type === "dropdown") {
      return (
        <select
          className={styles.input}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          disabled={disabled}
        >
          <option value="" disabled>
            {placeholder || "Select an option"}
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      );
    }

    if (type === "select") {
      return (
        <CategorySelector
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          fieldName={name}
          submitted={false}
          error={false}
          styles={styles}
        />
      );
    }

    if (type === "textarea") {
      return (
        <textarea
          className={styles.textArea}
          name={name}
          value={value ?? ""}
          placeholder={placeholder}
          required={required}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    }

    if (type === "list") {
      const listValue = Array.isArray(value) ? value.join("\n") : value ?? "";
      return (
        <textarea
          className={styles.textArea}
          name={name}
          value={listValue}
          placeholder={placeholder}
          required={required}
          onChange={(e) => {
            const lines = e.target.value.split("\n");
            onChange(lines);
          }}
        />
      );
    }

    if (type === "currency") {
      return (
        <div className={styles.inputWithPrefix}>
          <span className={styles.prefix}>₹</span>
          <input
            className={styles.input}
            type="number"
            name={name}
            min={0}
            step="0.01"
            value={value ?? ""}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            onChange={(e) => onChange(Number(e.target.value))}
          />
        </div>
      );
    }

    const inputType = type === "number" ? "number" : "text";
    const control = (
      <input
        className={styles.input}
        type={inputType}
        name={name}
        value={value ?? ""}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        onChange={(e) =>
          onChange(
            inputType === "number" ? Number(e.target.value) : e.target.value
          )
        }
      />
    );

    if (suffix) {
      return (
        <div className={styles.inputWithSuffix}>
          {control}
          <span className={styles.suffix}>{suffix}</span>
        </div>
      );
    }

    return control;
  };

  if (isStacked) {
    return (
      <div className={`${styles.inputContainer} ${styles.stackedContainer}`}>
        <div className={styles.formField}>
          {label}
          {required ? <span className={styles.requiredMark}>*</span> : null}
        </div>
        <div className={styles.stackedInputWrapper}>{renderControl()}</div>
      </div>
    );
  }

  return (
    <div className={styles.inputContainer}>
      <div className={styles.fieldRow}>
        <div className={styles.formField}>
          {label}
          {required ? <span className={styles.requiredMark}>*</span> : null}
        </div>
        <div className={styles.inputWrapper}>{renderControl()}</div>
      </div>
    </div>
  );
};
